var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon inf-alert-icon",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.339.308a3.019 3.019 0 011.385 1.37l6.964 14a2.983 2.983 0 01-1.385 4.015 3.074 3.074 0 01-1.34.308H3.037C1.359 20 0 18.657 0 17c0-.46.107-.912.311-1.324l6.964-14C8.015.19 9.835-.423 11.34.308zm-2.65 1.91l-.07.127-6.965 14a1.484 1.484 0 00-.154.656c0 .778.61 1.424 1.395 1.493l.14.007h13.929c.237 0 .471-.054.683-.157a1.487 1.487 0 00.756-1.867l-.058-.132-6.964-14a1.509 1.509 0 00-.57-.618l-.128-.07a1.556 1.556 0 00-1.993.56zM10 14a1 1 0 110 2 1 1 0 010-2zm0-9a1 1 0 011 1v6a1 1 0 01-2 0V6a1 1 0 011-1z"
  })));
}

export default SvgAlertIconSv;